import { environments } from '~/lib/const';

// revenue=100 — proxy: реальная маржа абонемента известна только после завершения периода (зависит от прочитанных глав → авторских роялти).
// Здесь шлём только сигнал о факте покупки, чтобы Direct видел конверсию и оптимизировал стратегию.
export const saveBuyAbonnementInECommerce = (transactionId?: number | null) => {
  if (environments.isClient && environments.isProduction) {
    (window as any).dataLayerSite.push({
      ecommerce: {
        currencyCode: 'RUB',
        purchase: {
          actionField: {
            revenue: 100,
            // Реальный ID заказа — позволяет Метрике/аналитике дедуплицировать покупку
            id: transactionId ?? 0,
          },
          products: [
            {
              id: 'abonnement',
              name: 'Абонемент',
              price: 100,
              brand: 'Абонемент',
              quantity: 1,
            },
          ],
        },
      },
    });
  }
};
